import "./App.css";

import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Button, IconButton } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import ExitToApp from '@material-ui/icons/ExitToApp';
import HelpOutline from '@material-ui/icons/HelpOutline';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ListIcon from '@material-ui/icons/List';
import TimelineIcon from '@material-ui/icons/Timeline';
import WbSunnyIcon from '@material-ui/icons/WbSunny';

import { appConfig } from './config.js';
import Login from "./components/Login";
import KpiDataGrid from "./components/KpiDataGrid";
import NetworksList from "./components/NetworksList";
import CellsList from "./components/CellsList";
import DatesSelector from "./components/DatesSelector";
import KpiChart from "./components/KpiChart";
import SolarChart from "./components/SolarChart";

import VanuLogo from "./images/vanu-purple.png";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    gridPadding: {
        padding: '10px'
    },
    activeTool: {
        paddingLeft: '10px',
        padding: '1px',
        width: 50,
    }
}));

const getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
};


function App() {

    const baseURL = appConfig.api.URL;
    const emsToken = getCookie('vanu_ems_token');
    let userIsAuthenticated = false;
    if (emsToken) userIsAuthenticated = true;

    const [username, setUsername] = useState(getCookie('vanu_ems_user'));
    const [token, setToken] = useState(emsToken);
    const [isAuthenticated, setIsAuthenticated] = useState(userIsAuthenticated);
    const [dateLastDay, setDateLastDay] = useState(new Date());
    const [fromDate, setFromDate] = useState(dateLastDay);
    const [toDate, setToDate] = useState(dateLastDay);
    const [networkName, setNetworkName] = useState('MRWAVB1');
    const [networks, setNetworks] = useState([]);
    const [cells, setCells] = useState([]);
    const [selectedCells, setSelectedCells] = useState([]);
    const [activeTool, setActiveTool] = React.useState('grid');

    const changeActiveTool = (event, newValue) => {
        setActiveTool(newValue);
    };


    useEffect(() => {
        if (isAuthenticated) {
            loadNetworkList();
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            loadNetworkList();
        }
    }, [isAuthenticated]);

    function onLogin(token, username) {
        setUsername(username);
        setToken(token);
        setIsAuthenticated(true);
    };

    function loadNetworkList() {
        let url_networks = `${baseURL}/networks/`;
        fetch(url_networks, {
            method: 'GET',
            headers: {
                'Authorization': `Token ${token}`
            }
        })
            .then(results => results.json())
            .then(data => {
                setNetworks(data);
            }
            )

        updateNetwork(networkName);
    }

    function onLogout() {
        document.cookie = "vanu_ems_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        document.cookie = "vanu_ems_user=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        setUsername(null)
        setToken(null)
        setIsAuthenticated(false);
    };

    function dateToString(inDate) {
        let dateUTC = new Date(Date.UTC(inDate.getFullYear(), inDate.getMonth(), inDate.getDate()));
        let strDate = dateUTC.toISOString().slice(0, 10);
        return strDate;
    }

    function updateDatesRange(newFromDate, newToDate) {
        setFromDate(newFromDate);
        setToDate(newToDate);
    }

    function updateNetwork(networkName) {
        setNetworkName(networkName);
        // last available date
        let url = `${baseURL}/kpis/?limit=1&network=${networkName}`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Token ${token}`
            }
        })
            .then(results => results.json())
            .then(data => {
                if (data.count > 0) {
                    let strDate = data.results[0].date_kpi.slice(0, 10);
                    let parts = strDate.split('-');
                    setDateLastDay(new Date(parts[0], parts[1] - 1, parts[2]));
                }
            }
            )
        updateCells(networkName);
        setSelectedCells([]);
    }

    function updateCells(networkName) {
        let url = `${baseURL}/cells/?network__bsc_name=${networkName}`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Token ${token}`
            }
        })
            .then(results => results.json())
            .then(data => {
                if (data.length > 0) {
                    setCells(data);
                }
            }
            )
    }

    function updateSelectedCells(cell, selected){
        if (selected) {
            setSelectedCells([...selectedCells, cell]);
        } else {
            setSelectedCells(selectedCells.filter(item => item !== cell));
        }
    }

    function exportData(){
        let url = `${baseURL}/export_report/?network_name=${networkName}&from_date=${dateToString(fromDate)}&to_date=${dateToString(toDate)}&device_names=${selectedCells.join(',')}`;
        if (activeTool === 'solar'){
            url = `${url}&data_type=solar`
        } else {
            url = `${url}&data_type=ems`
        }
        window.open(url);
    }

    const classes = useStyles();

    return (
        <div>
            <Grid container className={classes.gridPadding}>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={1}>
                    <img
                        src={VanuLogo}
                        className="app-logo"
                        alt="Welcome to Vanu Networks KPI Dashboard"
                    />
                </Grid>
                <Grid item xs={5}>
                    <div className="header-text">VANU NETWORKS KPI DASHBOARD</div>
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={1}>
                    {username ? `Welcome ${username}` : ''}
                </Grid>
                <Grid item xs={1}>
                    {username ?
                        <IconButton
                            aria-label="logout"
                            onClick={onLogout}
                        >
                            <ExitToApp />
                        </IconButton>
                        : <div></div>
                    }
                    <IconButton
                        aria-label="help"
                    >   <a href="/help/index.html" target="_blank">
                            <HelpOutline />
                        </a>
                    </IconButton>
                </Grid>
            </Grid>

            <div hidden={token != null}>
                <Login logged={false} onLogin={onLogin} />
            </div>

            <div hidden={token == null}>

                <Grid container className={classes.gridPadding}>

                    <Grid item xs={2}>

                        <ToggleButtonGroup
                            value={activeTool}
                            exclusive
                            onChange={changeActiveTool}
                            aria-label="text alignment"
                            className={classes.activeTool}
                        >
                            <ToggleButton value="grid" aria-label="show grid">
                                <ListIcon fontSize="small" />
                            </ToggleButton>
                            <ToggleButton value="chart" aria-label="show chart">
                                <TimelineIcon fontSize="small" />
                            </ToggleButton>
                            <ToggleButton value="solar" aria-label="show solar">
                                <WbSunnyIcon fontSize="small" />
                            </ToggleButton>
                        </ToggleButtonGroup>

                    </Grid>

                    <Grid item xs={2}>
                        <NetworksList
                            selectedNetworkName={networkName}
                            networks={networks}
                            onNetworkChange={updateNetwork}
                        />
                    </Grid>

                    <Grid item xs={1}>
                        <CellsList
                            cells={cells}
                            selectedCells={selectedCells}
                            onCellsSelectionChange={updateSelectedCells}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <DatesSelector
                            dateLastDay={dateLastDay}
                            onUpdateDateRanges={updateDatesRange}
                        />
                    </Grid>

                    <Grid item xs={1}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={exportData}
                        >Export
                        </Button>
                    </Grid>

                    <Grid item xs={12}>

                        <div>
                        {
                            activeTool === 'grid' && 
                            <KpiDataGrid
                                networkName={networkName}
                                selectedCells={selectedCells}
                                fromDate={fromDate}
                                toDate={toDate}
                                token={token}
                            />
                        }
                        </div>

                        <div>
                        {
                            activeTool === 'chart' && 
                            <KpiChart
                                networkName={networkName}
                                selectedCells={selectedCells}
                                fromDate={fromDate}
                                toDate={toDate}
                                token={token}
                            />
                        }
                            
                        </div>

                        <div>
                        {
                            activeTool === 'solar' && 
                            <SolarChart
                                cells={cells}
                                selectedCells={selectedCells}
                                fromDate={fromDate}
                                toDate={toDate}
                                token={token}
                            />
                        }
                        </div>

                    </Grid>
                </Grid>
            </div>
        </div>

    );
}

export default App;